import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetServerLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getServerLicensingConsumptionInfo', {});
  }
}
